export default __webpack_public_path__ + "static/media/018-Segway.099383d2.svg";